import { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../contexts/AuthContext';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      const hash = window.location.hash;
      const sessionIdMatch = hash.match(/session_id=([^&]+)/);
      
      if (!sessionIdMatch) {
        navigate('/');
        return;
      }

      const sessionId = sessionIdMatch[1];

      try {
        const response = await axios.post(
          `${API}/auth/session`,
          { session_id: sessionId },
          { withCredentials: true }
        );

        setUser(response.data);
        
        // Clear hash
        window.history.replaceState(null, '', window.location.pathname);
        
        // Check login intent from sessionStorage
        const loginIntent = sessionStorage.getItem('kyloo_login_intent');
        
        if (loginIntent === 'professional') {
          sessionStorage.removeItem('kyloo_login_intent');
          navigate('/dashboard', { replace: true });
        } else {
          sessionStorage.removeItem('kyloo_login_intent');
          // Redirect based on current path or default to home
          const currentPath = window.location.pathname;
          if (currentPath === '/dashboard' || currentPath === '/negoziante') {
            navigate('/dashboard', { replace: true });
          } else {
            navigate('/home', { replace: true });
          }
        }
      } catch (error) {
        console.error('Auth callback error:', error);
        navigate('/');
      }
    };

    processAuth();
  }, [navigate, setUser]);

  return (
    <div 
      className="min-h-screen flex items-center justify-center"
      style={{
        background: 'linear-gradient(135deg, #1a4fd8 0%, #2563EB 50%, #1a4fd8 100%)'
      }}
    >
      <div className="text-center">
        <div className="w-12 h-12 border-4 border-white border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
        <p className="text-white/80">Autenticazione in corso...</p>
      </div>
    </div>
  );
}
